import { Box, SuccessAnimation, Text } from '@ksyos/design-system';
import { useEffect } from 'react';
import { TwoFactorAuthenticationType } from '../../../../common/enums/twoFactorAuthenticationType';

interface IMfaSuccessScreenProps {
    mfaType: TwoFactorAuthenticationType;
    redirectToHome?: boolean;
}

export function MfaSuccessScreen(props: IMfaSuccessScreenProps) {
    useEffect(() => {
        if (props.redirectToHome) {
            setTimeout(() => (window.location.href = '/home'), 2000);
        }
    }, []);

    return (
        <>
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
            >
                <SuccessAnimation size="large" />
            </Box>
            <Text textAlign="center">
                Klaar! Vanaf nu kan je inloggen in Ksyos met wachtwoord en{' '}
                {props.mfaType === TwoFactorAuthenticationType.verificationDevice ? 'hardware token' : 'verificatieapp'}
                .
            </Text>
        </>
    );
}
